// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZjGt","placeholdersHeader":"styles_placeholdersHeader__3dtWP","editorStyle":"styles_editorStyle__3xQgj","placeholdersBox":"styles_placeholdersBox__3Y-L4"};